import React from "react";
import { amazonUpload } from "../utils/amazonUpload";
function Images(props) {
  const [value, setValue] = React.useState("https://www.bastiaanmulder.nl/wp-content/uploads/2013/11/dummy-image-square.jpg");
  React.useEffect(() => {
  
    if (props.value) {
      setValue(props.value.replace(/"/g,""));
    }
  
  }, []);

  const setObject = async (image) => {
    // object[name].find((item) => item.image_type == image.image_type);
    let uploadedImage = await amazonUpload(image);
    console.log("uploadedImage",uploadedImage);
    setValue(uploadedImage.location.replace(/"/g,""));
    props.setData(
      props.data.map((item) => {
        return item.ParameterId === props.id
          ? { ...item, Value: uploadedImage.location }
          : item;
      })
    );
  }


    return (
        
           
        <div class="col-md-4">  
        <div class="profile-pic-change d-flex">
        <img
          src={value}
          class="user-avatar"
         
        ></img>
      <div class="ml-3 form-group">
        <label >{props.name}</label>
        <input
          type="file"
          //value={value}
          onChange={(e) => setObject(e)}
          id={'param' + props.id}
          //placeholder={props.name}
          class="form-controlimg"
        />
      </div> 
      </div>
      </div>
    );
}

export default Images;

